export default {
  data() {
    return {
      reactionOptions: [
        {
          value: 'heart',
          icon: 'fas fa-grin-hearts',
          tooltip: this.$t('sessions.moodReactions.reactionHearts'),
        },
        {
          value: 'laugh',
          icon: 'fas fa-laugh-beam',
          tooltip: this.$t('sessions.moodReactions.reactionLaugh'),
        },
        {
          value: 'smile',
          icon: 'fas fa-smile',
          tooltip: this.$t('sessions.moodReactions.reactionSmile'),
        },
        {
          value: 'meh',
          icon: 'fas fa-meh',
          tooltip: this.$t('sessions.moodReactions.reactionMeh'),
        },
        {
          value: 'sad',
          icon: 'fas fa-sad-tear',
          tooltip: this.$t('sessions.moodReactions.reactionSad'),
        }, {
          value: 'crossbones',
          icon: 'fas fa-skull-crossbones',
          tooltip: this.$t('sessions.moodReactions.reactionCrossbones'),
        },
      ],
    };
  },

  computed: {
  },

  methods: {

  },
};
